class PostAPI {
  static all() {
    // fetch all urls and return promises
    return fetch(
      `/wp-json/wp/v2/posts?orderby=date&order=desc&per_page=100`
    ).then(response => {
      if (!response.ok) {
        throw Error(`Request rejected with status ${response.status}`)
      }
      return response.json()
    })
  }
}

export default PostAPI



// WEBPACK FOOTER //
// ./src/js/blog/api/PostAPI.js